import React from 'react'
import { DcButton } from 'pixel-base'
import FinanceActionBar from '../foundation/FinanceActionBar'
import { FinanceActionItem } from '../types'

interface Props {
  actions: FinanceActionItem[]
}

const variantMap = {
  primary: 'outline-primary',
  secondary: 'outline-secondary',
  success: 'outline-success',
  warning: 'outline-warning',
  danger: 'outline-danger',
} as const

const FinanceDocumentActions: React.FC<Props> = ({ actions }) => (
  <FinanceActionBar>
    {actions
      .filter((item) => !item.hidden)
      .map((item) => (
        <DcButton
          key={item.key}
          variant={variantMap[item.tone || 'secondary']}
          disabled={item.disabled}
          onClick={item.onClick}
        >
          {item.label}
        </DcButton>
      ))}
  </FinanceActionBar>
)

export default FinanceDocumentActions
